import Image from "next/image";

export const PRODUCT_TOKEN_GATING_INFORMATION = {
  title: "Unlock Exclusive Experiences with NFT Token Gating",
  highlight: "NFT Token Gating",
  description:
    "Create VIP experiences, premium content, and gated perks for your biggest fans — all powered by NFT ownership. With Mintology’s APIs, giving exclusive access has never been this easy (or this powerful).",
  image: "/images/products/tokengating-hero-image.webp",
  imageInfo: "Hero image for Mintology Token Gating page",
  bgImage: true,
  buttonText: "Launch Mintology Now!",
};
export const PRODUCT_TOKEN_GATING_BENEFITS = {
  title: "Why Token Gate with Mintology?",
  highlight: "Why",
  benefits: [
    {
      image: (
        <Image
          priority
          src="/images/products/token-verification-image.png"
          alt="Onboarding image"
          height={50}
          width={50}
          className="object-contain"
        />
      ),
      title: "Real‑Time Token Verification",
      description: "Verify NFT ownership instantly with Mintology's APIs.",
    },
    {
      image: (
        <Image
          priority
          src="/images/products/code-block-image.webp"
          alt="Onboarding image"
          height={60}
          width={60}
          className="object-contain"
        />
      ),
      title: "No-Code to Low-Code Setup",
      description: "No dev team? No problem. Integrate in hours, not months.",
    },
    {
      image: (
        <Image
          priority
          src="/images/products/enterprise-ready-image.webp"
          alt="Onboarding image"
          height={50}
          width={50}
          className="object-contain"
        />
      ),
      title: "Enterprise-Ready Security",
      description:
        "Top-tier encryption and seamless verification. Safe, secure, and built to scale.",
    },
  ],
};

export const PRODUCT_TOKEN_GATING_INTEGRATION = {
  title: "Easy API Integrations for Token Gating",
  highlight: "Easy API Integrations",
  description:
    "Mintology’s APIs slot right into your website, app, or platform. Instantly verify NFT ownership, automate access control, and customize the experience — all without wrecking your UX.",
};

export const PRODUCT_TOKEN_GATING_KEY_FEATURES = {
  title: "Token Gating Is the Upgrade You Didn’t Know You Needed",
  highlight: "Token Gating Is the Upgrade",
  description: "",
  features: [
    {
      attribute: "Elite",
      title: "VIP Memberships",
      description: "Make NFT ownership the key to premium memberships.",
    },
    {
      attribute: "Exclusive",
      title: "Exclusive Drops",
      description:
        "Token holders get first dibs on new products and limited editions.",
    },
    {
      attribute: "Private",
      title: "Private Communities",
      description:
        "Lock Discord channels, forums, and group chats to NFT holders only.",
    },
    {
      attribute: "Premium",
      title: "Premium Content",
      description:
        "Launch podcasts, videos, blogs — exclusively for your top fans.",
    },
    {
      attribute: "Privileged",
      title: "Loyalty Rewards",
      description: "Reward repeat customers with secret perks and benefits.",
    },
    {
      attribute: "Bounded",
      title: "Event Access",
      description:
        "Token holders score invites to virtual or in-person events, stress-free.",
    },
  ],
};

export const PRODUCT_TOKEN_GATING_SOLUTIONS = {
  title: "Token Gating, Supercharged by Mintology",
  highlight: "Supercharged by Mintology",
  solutions: [
    {
      icon: (
        <img
          alt="gated-content"
          src={"/icons/gated-content.svg"}
          className="w-16 h-16"
        />
      ),
      title: "Gated Content Access",
      description:
        "Lock premium content, videos, product drops, or membership areas behind NFT ownership. Only verified holders get in — no middlemen needed.",
    },
    {
      icon: (
        <img
          alt="event-and-experience"
          src={"/icons/event-and-experience.svg"}
          className="w-16 h-16"
        />
      ),
      title: "Event & Experience Access",
      description:
        "From virtual events to IRL experiences, give your NFT community a front-row seat. Instant verification, seamless entry.",
    },
    {
      icon: (
        <img
          alt="product-redemption"
          src={"/icons/product-redemption.svg"}
          className="w-16 h-16"
        />
      ),
      title: "Product Redemption",
      description:
        "Let NFT holders claim real-world rewards — merch, loyalty perks, exclusive drops — directly through your site. Fully automated, fully branded.",
    },
  ],
};

export const PRODUCT_TOKEN_GATING_CTA = {
  title: "Ready to Explore Token Gating? ",
  highlight: "Explore",
  buttonText: "Launch Mintology Now!",
};
